import { Context, Span } from '@opentelemetry/api'

export let globalActiveContext: Context | null = null
let ownerSpan: Span | null = null

export const setGlobalActiveContext = ({ ctx, owner }: { ctx: Context; owner: Span }) => {
    globalActiveContext = ctx
    ownerSpan = owner
}

export const clearGlobalActiveContextIfOwner = (span: Span) => {
    if (ownerSpan === span) {
        globalActiveContext = null
        ownerSpan = null
    }
}
